import React, {Suspense, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {Box, Card, CardContent, CardMedia, Container, Typography} from '@mui/material';
// import { Canvas } from "@react-three/fiber";
// import { OrbitControls, useGLTF } from "@react-three/drei";
import { useTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import { findProduct } from "../../utils/productCatalog";
import lodash from "lodash"
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { useGLTF } from "@react-three/drei";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import OBJModel from "./Obj"
import Grid from "@mui/material/Grid";
import { useProgress, Html } from "@react-three/drei";

function LoaderOverlay() {
  const { active, progress } = useProgress();
  if (!active) return null;

  // You can render an overlay div in DOM:
  return (
    <div style={{
      position: "absolute",
      left: 0, top: 0, right: 0, bottom: 0,
      display: "flex", alignItems: "center", justifyContent: "center",
      pointerEvents: "none", zIndex: 9999,
      background: "rgba(0,0,0,0.25)"
    }}>
      <div style={{
        padding: 16, borderRadius: 8, background: "white", color: "black",
        pointerEvents: "auto"
      }}>
        Loading... {Math.round(progress)}%
      </div>
    </div>
  );
}

const NextArrow = (props) => {
  const theme = useTheme();
  const { onClick, sx } = props;
  return (
    <IconButton
      onClick={onClick}
      color={"secondary"}
      sx={{
        position: "absolute",
        top: "35%",
        right: -50,
        zIndex: 1,
        // backgroundColor: theme.palette.secondary.main,
        // '&:hover': {
        //   backgroundColor: theme.palette.secondary.light,
        // },
        ...sx
      }}
    >
      <ArrowForwardIos />
    </IconButton>
  );
};

const PrevArrow = (props) => {
  const theme = useTheme();
  const { onClick, sx } = props;
  return (
    <IconButton
      onClick={onClick}
      color={"secondary"}
      sx={{
        position: "absolute",
        top: "35%",
        left: -50,
        zIndex: 1,
        // backgroundColor: theme.palette.secondary.main,
        // '&:hover': {
        //   backgroundColor: theme.palette.secondary.light,
        // },
        ...sx
      }}
    >
      <ArrowBackIos />
    </IconButton>
  );
};

function Model({ source, scale }) {
  const gltf = useGLTF(source); // path relative to public/

  return <primitive object={gltf.scene} scale={scale || 0.75} />;
}

const ProductPage = () => {
  const { productName } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();

  const { active, progress } = useProgress();

  const [ displayProductIndex, setDisplayProductIndex ] = useState(0)
  const data = findProduct(location.pathname)
  console.log(data)
  const product = {
    productImage: 'https://albaunggulmetal.co.id/wp-content/uploads/2023/08/artikel-05-scaled.jpg',
    specification: {
      catalogNo: "000-000",
      price: "Rp. 3.500.000",
      size: "500 (W) x 500 (D) x 1000 (H)",
    },
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum in diam quis placerat. Mauris tincidunt, elit at hendrerit laoreet, orci est vestibulum arcu, at sodales nulla nunc ut ligula. Nunc ut massa metus. Vivamus finibus diam elit. Nunc sed elementum ex. Interdum et malesuada fames ac ante ipsum primis in faucibus. Integer nibh sapien, mollis mollis magna sit amet, porttitor suscipit neque. Aenean ipsum quam, tincidunt eget ultrices et, tincidunt nec ex. Integer rhoncus dignissim tellus, eget commodo enim egestas eget. Duis augue ipsum, tempus id aliquam non, convallis eu sapien.",
    ...data.product
  }
  const otherProducts = data.others.map(p => ({
    productImage: 'https://albaunggulmetal.co.id/wp-content/uploads/2023/08/artikel-05-scaled.jpg',
    specification: {
      catalogNo: "000-000",
      price: "Rp. 3.500.000",
      size: "500 (W) x 500 (D) x 1000 (H)",
    },
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum in diam quis placerat. Mauris tincidunt, elit at hendrerit laoreet, orci est vestibulum arcu, at sodales nulla nunc ut ligula. Nunc ut massa metus. Vivamus finibus diam elit. Nunc sed elementum ex. Interdum et malesuada fames ac ante ipsum primis in faucibus. Integer nibh sapien, mollis mollis magna sit amet, porttitor suscipit neque. Aenean ipsum quam, tincidunt eget ultrices et, tincidunt nec ex. Integer rhoncus dignissim tellus, eget commodo enim egestas eget. Duis augue ipsum, tempus id aliquam non, convallis eu sapien.",
    ...p
  }))

  if (!product) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          pt: 10,
          pb: 6,
          backgroundColor: '#000000',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" sx={{ color: '#FFD700' }}>
          Product not found
        </Typography>
      </Box>
    );
  }

  const generateProductDisplay = product => {
    if (product.productModel) {
      return <>
        {
          product.productModel.length > 1 &&
          <PrevArrow
            sx={{ left: 0, top: "50%" }}
            onClick={() => setDisplayProductIndex(displayProductIndex === 0 ? product.productModel.length -1 : displayProductIndex - 1)}
          />
        }
        <Canvas camera={{ position: [0, 0, 10], fov: 75 }}>
          <ambientLight />
          <directionalLight position={[100, 500, 5]} />
          <Suspense fallback={null}>
            <OBJModel
              objPath={product.productModel[displayProductIndex][0]}
              mtlPath={product.productModel[displayProductIndex][1]}
              scale={product.productModelScale}
              position={[0, -2, 0]}
              rotation={[0, 45, 0]}
            />
          </Suspense>
          <OrbitControls />
        </Canvas>

        <LoaderOverlay />

        {/*<Canvas camera={{ position: [0, 0, 5], fov: 145 }}>*/}
        {/*  <ambientLight intensity={0.5} />*/}
        {/*  <directionalLight position={[2, 2, 2]} />*/}
        {/*  <Suspense fallback={null}>*/}
        {/*    <Model source={product.productModel[displayProductIndex]} scale={product.productModelScale} />*/}
        {/*  </Suspense>*/}
        {/*  <OrbitControls />*/}
        {/*</Canvas>*/}
        {
          product.productModel.length > 1 &&
          <NextArrow
            sx={{ right: 0, top: "50%" }}
            onClick={() => setDisplayProductIndex((displayProductIndex + 1) % product.productModel.length)}
          />
        }
      </>
    } else {
      return <Box
        component="img"
        src={product.productImage}
        alt={product.label}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'scale(1.02)',
          },
        }}
        onError={(e) => {
          e.target.src = '/images/default-product.jpg';
        }}
      />
    }
  }

  const availableColor = [
    { hex: "#fff8af", labelColor: "black", label: "RAL 1015 CREAM" },
    { hex: "#fffffd", labelColor: "black", label: "RAL 9003 SIGNAL WHITE" },
    { hex: "#619678", labelColor: "white", label: "RAL 6011 GREEN MACHINE" },
    { hex: "#d9dad5", labelColor: "black", label: "RAL 7035 LIGHT GREY" },
    { hex: "#9e9e9c", labelColor: "white", label: "RAL 7042 GREY" },
    { hex: "#1c1c1c", labelColor: "white", label: "RAL 9005 BLACK" },
    { hex: "#008cd3", labelColor: "white", label: "RAL 5012 SKY BLUE" },
    { hex: "#2f2681", labelColor: "white", label: "RAL 5002 BLUE" },
    { hex: "#2d2c4c", labelColor: "white", label: "RAL 5001 GREEN BLUE" },
    { hex: "#ffeb06", labelColor: "black", label: "RAL 1023 YELLOW" },
    { hex: "#e50412", labelColor: "white", label: "RAL 3000 RED" },
  ]

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        pt: { xs: 8, md: 10 },
      }}
    >
      <Container maxWidth="xl" sx={{ height: '100%' }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            alignItems: 'stretch',
            gap: { xs: 4, md: 8 },
            backgroundColor: '#ffffff',
            minHeight: 'calc(100vh - 80px)',
            // position: 'relative',
          }}
        >
          {/* Left Column - Product Image */}
          <Box
            sx={{
              position: 'sticky',
              top: 80,
              // height: { xs: '400px', md: 'calc(100vh - 80px)' },
              width: '100%',
              backgroundColor: '#f8f9fa',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            { generateProductDisplay(product) }
          </Box>

          {/* Right Column - Product Details */}
          <Box
            sx={{
              padding: { xs: 3, md: 6 },
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              backgroundColor: '#ffffff',
            }}
          >
            <Typography
              variant="h2"
              component="h1"
              sx={{
                color: '#1a1a1a',
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                fontWeight: 600,
                lineHeight: 1.2,
                marginBottom: 2,
              }}
            >
              {product.label}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#2c3e50',
                fontSize: { xs: '1rem', sm: '1.1rem' },
                lineHeight: 1.8,
                mb: 4,
                letterSpacing: '0.3px',
                textAlign: "justify"
              }}
            >
              {product.description}
            </Typography>

            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  color: '#1a1a1a',
                  fontWeight: 600,
                  fontSize: { xs: '1.25rem', sm: '1.5rem' },
                  mb: 3,
                  display: 'flex',
                  alignItems: 'center',
                  '&:before': {
                    content: '""',
                    width: '24px',
                    height: '3px',
                    background: 'linear-gradient(90deg, #FFD700 0%, #FFA500 100%)',
                    marginRight: '12px',
                    borderRadius: '2px',
                  }
                }}
              >
                Specification
              </Typography>

              <Box 
                component="ul" 
                sx={{ 
                  pl: 0,
                  listStyle: 'none',
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', sm: '1fr' },
                  gap: 2,
                }}
              >
                {Object.keys(product.specification).filter(key => product.specification[key]).map((spec, index) => (
                  <Typography
                    key={index}
                    component="li"
                    sx={{
                      color: '#2c3e50',
                      mb: 1,
                      pl: 3,
                      position: 'relative',
                      whiteSpace: 'pre-line',
                      '&:before': {
                        content: '""',
                        position: 'absolute',
                        left: 6,
                        top: 12.5,
                        transform: 'translateY(-50%)',
                        width: '6px',
                        height: '6px',
                        backgroundColor: '#FFD700',
                        borderRadius: '50%',
                      },
                      transition: 'transform 0.2s ease-in-out',
                      '&:hover': {
                        transform: 'translateX(5px)',
                        color: '#1a1a1a',
                      }
                    }}
                  >
                    {
                      spec === "dimension" ?
                        "Dimension: \n" + product.specification[spec] :
                        `${lodash.startCase(spec)}: ${product.specification[spec]}`
                    }
                  </Typography>
                ))}
              </Box>

              <Typography
                sx={{
                  color: '#2c3e50',
                  mb: 1,
                  pl: 3,
                  position: 'relative',
                  '&:before': {
                    content: '""',
                    position: 'absolute',
                    left: 6,
                    top: 12.5,
                    transform: 'translateY(-50%)',
                    width: '6px',
                    height: '6px',
                    backgroundColor: '#FFD700',
                    borderRadius: '50%',
                  },
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateX(5px)',
                    color: '#1a1a1a',
                  }
                }}
              >
                Available Color
              </Typography>
              <Box sx={{ width: "100%", maxWidth: 600, mx: "auto", padding: "0px 50px" }}>
                <Slider {...{
                  dots: true,
                  infinite: false,
                  speed: 500,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  arrows: true,
                  nextArrow: <NextArrow />,
                  prevArrow: <PrevArrow />,
                }}>
                  {availableColor.map((color, index) => (
                    <Box
                      key={index}
                      sx={{
                        backgroundColor: color.hex,
                        color: color.labelColor,
                        height: 100,
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 2,
                        mx: 1,
                        fontWeight: "bold",
                        fontSize: "14px",
                        boxShadow: 2,
                      }}
                    >
                      {color.label}
                    </Box>
                  ))}
                </Slider>
                {/*<Slider {...{*/}
                {/*  dots: false,*/}
                {/*  infinite: false,*/}
                {/*  speed: 500,*/}
                {/*  slidesToShow: Math.min(3, availableColor.length),*/}
                {/*  slidesToScroll: 1,*/}
                {/*  nextArrow: <NextArrow />,*/}
                {/*  prevArrow: <PrevArrow />,*/}
                {/*}}>*/}
                {/*  {availableColor.map((color, index) => (*/}
                {/*    <Box*/}
                {/*      key={index}*/}
                {/*      sx={{*/}
                {/*        backgroundColor: color.hex,*/}
                {/*        color: "#fff",*/}
                {/*        height: 100,*/}
                {/*        display: "flex",*/}
                {/*        alignItems: "center",*/}
                {/*        justifyContent: "center",*/}
                {/*        borderRadius: 2,*/}
                {/*        mx: 1,*/}
                {/*        fontWeight: "bold",*/}
                {/*        fontSize: "1.2rem",*/}
                {/*        boxShadow: 2,*/}
                {/*      }}*/}
                {/*    >*/}
                {/*      {color.label}*/}
                {/*    </Box>*/}
                {/*  ))}*/}
                {/*</Slider>*/}
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>

      <Container maxWidth="lg" sx={{ p: "40px" }}>
        <Typography
          component="h2"
          variant="h6"
          align="center"
          sx={{
            mb: 6,
            color: '#1a1a1a',
            fontWeight: 600,
            paddingTop: "20px",
            '&:after': {
              content: '""',
              display: 'block',
              width: '200px',
              height: '4px',
              background: 'linear-gradient(90deg, #FFD700 0%, #FFA500 100%)',
              margin: '20px auto 0',
              borderRadius: '2px',
            },
          }}
        >
          Other Product in this Category
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(3, 1fr)',
              md: 'repeat(3, 1fr)',
            },
            gap: 3,
          }}
        >
          {[...otherProducts].sort(() => Math.random() - 0.5).slice(-3).map((otherProduct, index) => (
            <Card
              key={index}
              onClick={() => navigate(otherProduct.path)}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                  '& .MuiCardMedia-root': {
                    transform: 'scale(1.05)',
                  }
                }
              }}
            >
              <CardMedia
                component="img"
                height="200"
                image={otherProduct.productModel[0][2]}
                alt={otherProduct.label}
                sx={{
                  bgcolor: "#fff",
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                {/*<Box*/}
                {/*  component="img"*/}
                {/*  image={otherProduct.productImage}*/}
                {/*  alt={otherProduct.label}*/}
                {/*  sx={{*/}
                {/*    width: '100%',*/}
                {/*    height: '100%',*/}
                {/*    objectFit: 'cover',*/}
                {/*    transition: 'transform 0.3s ease-in-out',*/}
                {/*    '&:hover': {*/}
                {/*      transform: 'scale(1.02)',*/}
                {/*    },*/}
                {/*  }}*/}
                {/*  onError={(e) => {*/}
                {/*    e.target.src = '/images/default-product.jpg';*/}
                {/*  }}*/}
                {/*/>*/}
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h6"
                  sx={{
                    fontWeight: 600,
                    color: '#ffd700',
                    mb: 2
                  }}
                >
                  {otherProduct.label}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ProductPage;
